
export enum Sources {
  API = 'api',
  SILENT = 'silent',
  USER = 'user'
}

export default Sources;
